import React from 'react';
import styled from '@emotion/styled'
import { Media } from '../../';


const ThoughtCardImageComponent = ({ image }) => (
  <ThoughtCardImageWrapper>
    {image && <Media image={image} />}
  </ThoughtCardImageWrapper>
);

export const ThoughtCardImageWrapper = styled.div`
    width: 100%;
    max-width: 680px;
    min-width: 50%;
    /* &::before {
        content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        padding-top: 66.66666666%;
    }
    &::after {
        content: '';
        display: table;
        clear: both;
    } */
    .gatsby-image-outer-wrapper {
        flex: 1 1 auto;
    }
    .gatsby-image-wrapper {
        width: 100%;
        height: 100%;
    }
    .media-svg{
      max-width: 100%;
    }
`;
export default ThoughtCardImageComponent;
